import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFileBend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"file-bend, document"} maskId="square-filled-radius-0-stroke-1-IconFileBend"><path d="M4 2H12.5V9.5H20V22H4V2Z" fill="currentColor"/><path d="M19.7071 8.50008L13.5 2.29297V8.50008H19.7071Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFileBend;
